import { render, staticRenderFns } from "./CheckAdmin.vue?vue&type=template&id=56fdc6f7&scoped=true"
import script from "./CheckAdmin.vue?vue&type=script&lang=js"
export * from "./CheckAdmin.vue?vue&type=script&lang=js"
import style0 from "./CheckAdmin.vue?vue&type=style&index=0&id=56fdc6f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fdc6f7",
  null
  
)

export default component.exports